import {RoleEnum} from '@pages/global/users/user-types';
import {WorkspaceResource} from '@workspaces/resources';
import {WorkspaceList, workspacesBasePath} from '@workspaces/workspaces';

const basePath = workspacesBasePath[WorkspaceList.BDESE];
export const checklistResources: WorkspaceResource[] = [
  {
    name: 'bdese/checklist',
    create: `${basePath}/checklists/new`,
    edit: `${basePath}/checklists/edit/:id`,
    list: `${basePath}/checklists`,
    show: `${basePath}/checklists/:id`,
    meta: {
      label: 'pages.bdese.labels.checklist',
      prefix: 'pages.bdese.checklist',
      canDelete: true,
      accessControl: {
        [RoleEnum.ROLE_ADMIN]: ['list', 'edit', 'delete', 'create', 'show'],
        [RoleEnum.ROLE_USER]: ['list', 'edit', 'delete', 'create', 'show'],
      },
    },
  },
  {
    name: 'bdese/checklist/consultation/enum',
    meta: {
      label: 'pages.bdese.labels.checklist',
      prefix: 'pages.bdese.checklist',
      accessControl: {
        [RoleEnum.ROLE_ADMIN]: ['list'],
        [RoleEnum.ROLE_USER]: ['list'],
      },
    },
  },
  {
    name: 'bdese/indicator',
    meta: {
      label: 'pages.bdese.labels.checklist',
      prefix: 'pages.bdese.checklist',
      accessControl: {
        [RoleEnum.ROLE_ADMIN]: ['list'],
        [RoleEnum.ROLE_USER]: ['list'],
      },
    },
  },
];
